module.exports = __webpack_public_path__ + "static/media/ines-forum-2.403d1dce.jpg";